export const FAQ_TITLE = "Questions about your trip?";
export const FAQ_CTA = "View FAQs";
